import { ElectronicCommerceIndicator, SecurePaymentsParesStatus } from '../../../api/types'

export const mapElectronicCommerceIndicator = (indicator: string): ElectronicCommerceIndicator => {
  switch (indicator) {
    case '00':
      return ElectronicCommerceIndicator.NON_3D_SECURE_TRANSACTION_MASTERCARD
    case '01':
      return ElectronicCommerceIndicator.ATTEMPTED_AUTHENTICATION_TRANSACTION_MASTERCARD
    case '02':
      return ElectronicCommerceIndicator.FULLY_AUTHENTICATED_TRANSACTION_MASTERCARD
    case '05':
      return ElectronicCommerceIndicator.FULLY_AUTHENTICATED_TRANSACTION_VISA
    case '06':
      return ElectronicCommerceIndicator.ATTEMPTED_AUTHENTICATION_TRANSACTION_VISA
    case '07':
      return ElectronicCommerceIndicator.NON_3D_SECURE_TRANSACTION_VISA
    default:
      return indicator as ElectronicCommerceIndicator
  }
}

export const mapParseStatusEnum = (status: string): SecurePaymentsParesStatus => {
  switch (status) {
    case 'Y':
      return SecurePaymentsParesStatus.SUCCESSFUL_AUTHENTICATION
    case 'N':
      return SecurePaymentsParesStatus.FAILED_AUTHENTICATION
    case 'U':
      return SecurePaymentsParesStatus.UNABLE_TO_COMPLETE_AUTHENTICATION
    case 'A':
      return SecurePaymentsParesStatus.SUCCESSFUL_ATTEMPTS_TRANSACTION
    case 'C':
      return SecurePaymentsParesStatus.CHALLENGE_REQUIRED_FOR_AUTHENTICATION
    case 'R':
      return SecurePaymentsParesStatus.REJECTED_AUTHENTICATION
    default:
      return SecurePaymentsParesStatus.REJECTED_AUTHENTICATION
  }
}
